import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";

import UsersInfoDrawerContent from "./Content";

const UsersInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple>
      <UsersInfoDrawerContent />
    </DrawerSimple>
  );
});

export const showUsersInfoDrawerNew = createDrawerTrigger(UsersInfoDrawer);
